import clsx from "clsx";
import React, { FC } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { RiCheckboxBlankCircleFill } from "react-icons/ri";

import styles from "./styles.module.scss";

export interface ChecklistProps {
  items: {
    key: string;
    name: string;
    value: boolean;
  }[];
}

export const Checklist: FC<ChecklistProps> = ({ items }) => {
  return (
    <ul className={styles.list}>
      {items.map(({ key, name, value }) => {
        return (
          <li key={key} className={clsx(value && styles.checked)}>
            <FaCheckCircle />
            <p>{name}</p>
          </li>
        );
      })}
    </ul>
  );
};
